/**
 * The words for "this hand was not accepted as a win", shared by the main device, round edits and a helper's phone so they can never
 * disagree. Two different problems get two different messages: an incomplete hand (check the tiles) and a hand below the table's
 * minimum fan (the house rules) — the second always names the minimum.
 */

import type { ScoreResult } from './types';

export const INCOMPLETE_HAND_MESSAGE = 'The winning hand is not complete yet — please check your tile selection.';

export function describeRejection(result: Pick<ScoreResult, 'rejection' | 'notes'>): string {
  const why = result.rejection;
  if (why?.kind === 'incomplete') return INCOMPLETE_HAND_MESSAGE;
  if (why?.kind === 'below_minimum') {
    const worth = why.fan === 0 ? 'has no scoring pattern (0 fan)' : `is worth only ${why.fan} fan`;
    return `This hand ${worth}, but this table's house rules need at least ${why.minimum} fan to win.`;
  }
  // A ruleset that cannot say why: its own note if it wrote one, otherwise a plain catch-all.
  return result.notes.find((n) => n.includes('minimum') || n.includes('shape')) ?? "This hand is not a valid win under this table's rules.";
}
